import React, { useEffect, useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart, LinearScale, CategoryScale } from "chart.js/auto";
// Chart.register(LinearScale,CategoryScale);
import { dashboardCountData, dashboardProjectsData, getService, recommendedProvider, serviceSummery, completedServicesSummery, fetchJobsCount } from '../../services/auth.service';
import Filter from './filter';
import './dashboard.scss'
import { CalendarIcon, FilterIcon } from '../../components/Icons';
import ReviewSummary from '../../assets/images/review-summary.svg'
import JobSummary from '../../assets/images/job-sumary.svg'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { selectUser } from '../../slice/authSlice';
import { getFullName } from '../../utils/common';
import { useSelector, useDispatch } from 'react-redux';
import { setLoader } from '../../slice/commonSlice';
import { CiCircleInfo } from 'react-icons/ci';
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom';

function Dashboard() {
    const dispatch = useDispatch()
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const [filterModal, setfilterModal] = useState(false);

    const [filterData, setFilterData] = useState(null);

    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonthT, setSelectedMonthT] = useState(currentMonth);
    const [selectedYearT, setSelectedYearT] = useState(currentYear);

    const [earningsGraphLabel, setEarningGraphLabel] = useState()
    const [earningsGraphValue, setEarningGraphValue] = useState()
    const [timeGraphLabel, settimeGraphLabel] = useState()
    const [timeGraphValue, settimeGraphValue] = useState()


    const [revenue, setRevenue] = useState(0)
    const [completeJob, setCompleteJob] = useState(0)
    const [cancelledJob, setCancelledJob] = useState(0)
    const [ongoingJob, setOngoingJob] = useState(0)
    const [status, setStatus] = useState(0)
    const [jobRequestCount, setJobRequestCount] = useState(0)
    const [services, setServices] = useState([]);

    const user = useSelector(selectUser);


    const startdate = new Date();
    const firstDayOfMonth = new Date(startdate.getFullYear(), startdate.getMonth(), 1);
    const [startDate, setStartDate] = useState();
    const lastDayOfMonth = new Date(startdate.getFullYear(), startdate.getMonth() + 1, 0);
    const [endDate, setEndDate] = useState();

    const [selectedOption, setSelectedOption] = useState();
    const [timePeriod, setTimePeriod] = useState();

    const [message, setMessage] = useState();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const [keysArray, setKeysArray] = useState([]);
    const [valuesArray, setValuesArray] = useState([]);

    const [serviceNameArr, setserviceNameArr] = useState([]);
    const [serviceCountArr, setserviceCountArr] = useState([]);

    const years = Array.from({ length: 10 }, (_, index) => currentYear - index);
    const months = [
        { value: "01", label: 'January' },
        { value: "02", label: 'February' },
        { value: "03", label: 'March' },
        { value: "04", label: 'April' },
        { value: "05", label: 'May' },
        { value: "06", label: 'June' },
        { value: "07", label: 'July' },
        { value: "08", label: 'August' },
        { value: "09", label: 'September' },
        { value: "10", label: 'October' },
        { value: "11", label: 'November' },
        { value: "12", label: 'December' },
    ];

    // const years = [
    //     { value: 2022, label: 2022 },
    //     { value: 2023, label: 2023 }
    // ]

    const timePeriods = [
        { value: "1 week", label: "1 Week" },
        { value: "1 month", label: "1 Month" },
        { value: "3 month", label: "3 Month" },
    ]

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
        setStatus(1)
    };

    const handleYearChange = (event) => {
        setSelectedYear(parseInt(event.target.value, 10));
        setStatus(1)
    };

    const handleMonthChangeT = (event) => {
        setSelectedMonthT(event.target.value);
        // console.log(selectedMonthT, "selected month")

        setStatus(2)

    };

    const handleYearChangeT = (event) => {
        setSelectedYearT(event.target.value);
        // console.log(selectedYearT, "selected year")
        setStatus(2)

    };

    const fetchData = async () => {
        try {
            let res = await getService();
            // console.log(res, "getservice");
            setServices(res.data.services);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const DashboardCountData = async () => {
        if (status == 1) {
            let formattedDate = `${selectedYear}-${selectedMonth}`;
            const res = await dashboardCountData(formattedDate, 'earnings');
            if (res) {
                setEarningGraphLabel(res.data.dataX)
                setEarningGraphValue(res.data.dataY)
            }
        } else if (status == 2) {
            // console.log(timeGraphLabel, timeGraphLabel, "timeGraphLabel,timeGraphLabel");

            let formattedDate = `${selectedYearT}-${selectedMonthT}`;
            const res = await dashboardCountData(formattedDate, 'time');
            if (res) {
                settimeGraphLabel(res.data.dataX)
                settimeGraphValue(res.data.dataY)
            }
        } else {
            let formattedDate = `${selectedYear}-${selectedMonth}`;
            const res = await dashboardCountData(formattedDate, 'earnings');
            // console.log(res, "earnings response")
            if (res) {
                setEarningGraphLabel(res.data.dataX)
                setEarningGraphValue(res.data.dataY)
            }
            let formattedDate1 = `${selectedYearT}-${selectedMonthT}`;
            const res1 = await dashboardCountData(formattedDate1, 'time');
            if (res1) {
                settimeGraphLabel(res1.data.dataX)
                settimeGraphValue(res1.data.dataY)
            }
        }

    }

    const getServiceSummery = async () => {
        const result = await serviceSummery();
        // console.log("result==>",result?.data?.statusCounts)
        const data = result?.data?.statusCounts;

        setKeysArray(Object.keys(data));
        setValuesArray(Object.values(data));
    }

    const getCompleteServiceSummery = async () => {
        const result = await completedServicesSummery();
        // console.log("getCompleteServiceSummery==>",result?.data?.serviceSummery)
        const data = result?.data?.serviceSummery;
        setserviceNameArr(Object.keys(data));
        setserviceCountArr(Object.values(data));
    }
    const serviceSelect = (event) => {
        setSelectedOption(event.target.value);
    };

    const handlePeriodChange = (event) => {
        setTimePeriod(event.target.value);
    };
    const clearFilter = () => {
        setStartDate();
        setEndDate();
        setTimePeriod(" ");
        setSelectedOption(" ");
        // console.log(timePeriod, "timePeriodtimePeriod")
    }

    const filter = async () => {
        // console.log("filter", startDate, endDate, timePeriod, selectedOption)
        let res = await dashboardProjectsData(startDate, endDate, timePeriod, selectedOption);
        // console.log(res.data, "res for daashboard calling first time")
        // var button = document.getElementById('dropdown-basic');
        // button.addEventListener('click');
        const revenueValue = res?.data?.revenue || 0;

        setRevenue(revenueValue);
        setOngoingJob(res?.data?.statusCounts?.ON || 0);
        setCompleteJob(res?.data?.statusCounts?.CO || 0);
        setCancelledJob(res?.data?.statusCounts?.CN || 0);
        setIsDropdownOpen(false);
        // props.filterDataParent(res)
    }

    const fetchJoblistCount = async () => {
        await dispatch(setLoader(true));
        try {
            const response = await fetchJobsCount();
            await dispatch(setLoader(false));
            setJobRequestCount(response?.data?.jobRequestCount);
        } catch (error) {
            await dispatch(setLoader(false));
            console.error("Error fetching profile data:", error);
        }
    };

    useEffect(() => {
        // if (status1 == 0) {
        //     filter()
        //     setStatus1(1)
        // }
        DashboardCountData();
        fetchJoblistCount()
        fetchData();
        filter();
        getServiceSummery();
        getCompleteServiceSummery();
    }, [selectedMonth, selectedYear, selectedMonthT, selectedYearT]);


    const data = {
        labels: earningsGraphLabel,

        datasets: [
            {
                label: 'Earning Bar Chart',
                backgroundColor: 'rgba(127,41,214,0.4)',
                borderColor: 'rgba(127,41,214,0.8)',
                borderWidth: 1,
                hoverBackgroundColor: '#7F29D6',
                hoverBorderColor: '#7F29D6',
                data: earningsGraphValue,
            },

        ],

    };

    const data1 = {
        labels: timeGraphLabel,
        datasets: [
            {
                label: 'Time Bar Chart',
                backgroundColor: 'rgba(127,41,214,0.4)',
                borderColor: 'rgba(127,41,214,0.8)',
                borderWidth: 1,
                hoverBackgroundColor: '#7F29D6',
                hoverBorderColor: '#7F29D6',
                data: timeGraphValue,
            },
        ],
    };

    const completedServicePie = {
        labels: serviceNameArr,


        datasets: [
            {
                data: serviceCountArr,
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4CAF50', '#4CAF00'],
                hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4CAF50', '#4CAF00'],
            },
        ],
    };

    const jobSummery = {
        labels: keysArray,
        datasets: [
            {
                data: valuesArray,
                backgroundColor: ['#4CAF50', '#FFCE56', '#FF6384'],
                hoverBackgroundColor: ['#4CAF50', '#FFCE56', '#FF6384'],
            },
        ],
    }

    const options1 = {
        type: 'doughnut',
        data: data,
        plugins: {
            legend: {
                position: 'bottom',
            },
        },

    };

    // Chart configuration options
    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    const handleFilterChange = (data) => {
        setFilterData(data);
        // console.log(filterData, "filtered data")
    };

    const filterDataParent = (newMessage) => {
        // console.log("data pass");
        setMessage(newMessage);
        // console.log(newMessage.data, "new message")
        setRevenue(newMessage?.data?.revenue)
        setOngoingJob(newMessage?.data?.statusCounts?.ON)
        setCompleteJob(newMessage?.data?.statusCounts?.CO)
        setCancelledJob(newMessage?.data?.statusCounts?.CN)
    }
    const handleDataFromChild = (data) => {
        // setReceivedData(data); // Receive data from the child component
        // console.log(data, "data from child")
    };

    return (
        <>
            <Header />
            {jobRequestCount > 0 &&
                <div className="info-icon-container">
                    <div className="sub-info-container">
                        <div className="info-icon-left">
                            <CiCircleInfo size={35} />
                        </div>
                        <div className="info-icon-right">
                            <div>
                                <span> There are {jobRequestCount} job request(s) pendings </span>
                            </div>
                            <div>
                                <Link to="/provider/jobrequest" style={{ color: '#FFF' }}><MdKeyboardArrowRight size={30} /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {/* <p>Completed Job:</p>{completeJob}
            <p>Current Job:</p>{ongoingJob}
            <p>Cancelled Job</p>:{cancelledJob}
            <p>Revenue:</p>{revenue}

            <div onClick={() => setfilterModal(true)}>Filter</div>
            {filterModal ? <Filter setfilterModal={setfilterModal} filterModal={filterModal} filterDataParent={filterDataParent} /> : ''}
           
            <select id="month" onChange={handleMonthChange} value={selectedMonth}>
                {months.map((month) => (
                    <option key={month.value} value={month.value}>
                        {month.label}
                    </option>
                ))}
            </select>

            <label htmlFor="year">Year:</label>
            <select id="year" onChange={handleYearChange} value={selectedYear}>
                {years.map((year) => (
                    <option key={year.value} value={year.value}>
                        {year.label}
                    </option>
                ))}
            </select> */}
            {/* <div class="chart-box">
                <h2>Earning Chart</h2>
                <Bar data={data} options={options} /> */}
            <div className='dashboard-top'>
                <div className='container-wrap'>
                    <div className='dashborad-title-wrap'>
                        <div className='dashboard-title text-truncate'>
                            Hi, {getFullName(user?.firstName, user?.lastName)}
                        </div>
                        {/* <div className='filter-wrap' onClick={() => setfilterModal(true)}> */}
                        <div className='filter-wrap' >


                            <Dropdown show={isDropdownOpen} onToggle={(isOpen) => setIsDropdownOpen(isOpen)}>
                                <Dropdown.Toggle id="dropdown-basic">
                                    <span>Filter</span> <i><FilterIcon /></i>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <div className='filter-form'>
                                        <div className='filter-title'>Filter Jobs Overview</div>
                                        <Form>
                                            <Row className='g-2 flex-column'>
                                                <Col>
                                                    <Form.Label>Start Date</Form.Label>
                                                    <DatePicker className='form-control' selected={startDate} onChange={(date) => setStartDate(date)} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>End Date</Form.Label>
                                                    <DatePicker className='form-control' selected={endDate} onChange={(date) => setEndDate(date)} />
                                                </Col>
                                                <Col>
                                                    <Form.Label>Filter by time period</Form.Label>
                                                    <Form.Select value={timePeriod} onChange={handlePeriodChange}>
                                                        <option key=" ">Select Time Period</option>
                                                        {timePeriods.map((timePeriods) => (
                                                            <option key={timePeriods.value} value={timePeriods.value}>
                                                                {timePeriods.label}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col>
                                                    <Form.Label>Service</Form.Label>
                                                    <Form.Select value={selectedOption} onChange={serviceSelect}>
                                                        <option key=" ">Select Service</option>
                                                        {services.map(service => (
                                                            <option key={service._id} value={service._id}>
                                                                {service.name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col className='mt-3'>
                                                    <Row>
                                                        <Col xs={6}><div className="d-grid"><Button variant="outline-primary" onClick={clearFilter}>Clear Filter</Button></div></Col>
                                                        <Col xs={6}><div className="d-grid"><Button variant="primary" onClick={filter}>Apply Filter</Button></div></Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>

                                </Dropdown.Menu>
                            </Dropdown>


                        </div>
                    </div>
                    <div className='stats-wrapper'>
                        <Row className='g-4'>
                            <Col lg={3} sm={6}>
                                <div className='stats-box h-100'>
                                    <div className='stats-title'>Completed Jobs</div>
                                    <div className='stats-value'>{completeJob}</div>
                                </div>
                            </Col>
                            <Col lg={3} sm={6}>
                                <Link to="/provider/jobs" style={{ textDecoration: 'none' }}>
                                    <div className='stats-box h-100'>
                                        <div className='stats-title'>Current Jobs</div>
                                        <div className='stats-value'>{ongoingJob}</div>
                                    </div>
                                </Link>
                            </Col>
                            <Col lg={3} sm={6}>
                                <div className='stats-box h-100'>
                                    <div className='stats-title'>Cancelled Jobs</div>
                                    <div className='stats-value'>{cancelledJob}</div>
                                </div>
                            </Col>
                            <Col lg={3} sm={6}>
                                <div className='stats-box h-100'>
                                    <div className='stats-title'>Total Earning</div>
                                    <div className='stats-value'>${revenue}</div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            <div className='main-container'>
                <div className='container-wrap'>
                    <div className='chart-main-wrapper'>
                        <div className='summary-wrap'>
                            <Row className='g-4'>
                                <Col md={6}>
                                    <div className='summary chart-box h-100'>
                                        <div className='summary-title'>Service Summary </div>
                                        {serviceCountArr.length > 0 ? <Doughnut data={completedServicePie} options={options1} /> : "No Data Found!"}
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className='summary chart-box h-100'>
                                        <div className='summary-title'>Job Summary </div>
                                        {valuesArray.length > 0 ? <Doughnut data={jobSummery} options={options1} /> : "No Data Found!"}
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <div className='chart-box'>
                            <div className='barchart-wrapper'>
                                <div className='bar-chart-top'>
                                    <div className='barchart-title'>Total Timing</div>
                                    <div className='barchart-filter'>
                                        <label htmlFor="month">Month:</label>
                                        <Form.Select id="month" className='month' onChange={handleMonthChangeT} value={selectedMonthT}>
                                            {months.map((month) => (
                                                <option key={month.value} value={month.value}>
                                                    {month.label}
                                                </option>
                                            ))}
                                        </Form.Select>

                                        <label htmlFor="year">Year:</label>
                                        <Form.Select id="year" onChange={handleYearChangeT} value={selectedYearT}>
                                            {years.map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                </div>
                                <div className='w-100 barchart-wrap'>
                                    <Bar data={data1} options={options} />
                                </div>
                            </div>

                        </div>

                        <div className='chart-box'>
                            <div className='barchart-wrapper'>
                                <div className='bar-chart-top'>
                                    <div className='barchart-title'>Total Earning</div>

                                    <div className='barchart-filter'>
                                        <label htmlFor="month">Month:</label>
                                        <Form.Select id="month" className='month' onChange={handleMonthChange} value={selectedMonth}>
                                            {months.map((month) => (
                                                <option key={month.value} value={month.value}>
                                                    {month.label}
                                                </option>
                                            ))}
                                        </Form.Select>

                                        <label htmlFor="year">Year:</label>
                                        <Form.Select id="year" onChange={handleYearChange} value={selectedYear}>
                                            {years.map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                </div>
                                <div className='w-100 barchart-wrap'>
                                    <Bar data={data} options={options} />
                                </div>
                            </div>

                        </div>

                        {filterModal ? <Filter setfilterModal={setfilterModal} filterModal={filterModal} sendDataToParent={handleDataFromChild} /> : ''}


                    </div>
                </div>
            </div>

            <Footer />


        </>
    )
}

export default Dashboard